export default {
    stat: {
        todo: [],
        monitor: [],
        snap: [],
        handle: [],
        handle_rank: []
    }
}
